module.exports = __webpack_public_path__ + "static/img/pic_cpraedbm@2x.87218311.png";